var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCommonIconSleepingColor(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 25 25"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#E1BEE7",
    d: "M10 19.063H2.5a.624.624 0 01-.625-.625v-1.875c0-.346.28-.625.625-.625H10c.346 0 .625.279.625.624v1.875c0 .346-.28.625-.625.625z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF9800",
    d: "M3.125 23.438H0v-15h3.125v9.374H25v5.625h-3.125v-2.5H3.125z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BA68C8",
    d: "M9.375 12.188c.339 1.172.727 3.75.727 3.75H6.977c-1.036 0-1.456-.695-1.875-1.876L3.94 10c-.352-1.093.57-2.187 1.577-2.187h.732c1.035 0 2.13.757 2.5 1.875l.625 2.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9C27B0",
    d: "M25 13.873c0-.977-.705-1.685-1.677-1.685H9.375v5.624H25v-3.94z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.313 1.563a2.813 2.813 0 11-.002 5.626 2.813 2.813 0 01.002-5.627m6.044 11.251H7.861l-.793-3.47c-.235-.654-.754-1.137-1.553-.865-.798.27-.794 1.232-.515 1.834L6.106 14a1.088 1.088 0 00.977.687h4.275s.86.04.86-.918c0-.958-.86-.957-.86-.957z",
    fill: "#FFB74D"
  }))));
}

export default SvgCommonIconSleepingColor;